import { createContext, useContext, useState } from "react";

const RegionContext = createContext(null);

export const REGIONS = {
  UK: { code: "UK", label: "United Kingdom", short: "UK", flag: "🇬🇧", currency: "£" },
  US: { code: "US", label: "United States", short: "US", flag: "🇺🇸", currency: "$" },
};

export function RegionProvider({ children }) {
  const [region, setRegionState] = useState(() => {
    try {
      const p = new URLSearchParams(window.location.search).get("region");
      const up = p && p.toUpperCase();
      if (up === "US" || up === "UK") return up;
      return localStorage.getItem("vn_region") || "UK";
    } catch {
      return "UK";
    }
  });

  const setRegion = (code) => {
    try {
      localStorage.setItem("vn_region", code);
      const url = new URL(window.location.href);
      url.searchParams.set("region", code);
      window.history.replaceState({}, "", url);
    } catch {}
    setRegionState(code);
  };

  return (
    <RegionContext.Provider value={{ region, setRegion, meta: REGIONS[region] }}>
      {children}
    </RegionContext.Provider>
  );
}

export const useRegion = () => useContext(RegionContext);
